import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/pages/index'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/management',
      redirect: '/management/index'
    },
    {
      path: '/management/index',
      name: 'managementIndex',
      component: () => import(/* webpackChunkName: "managementIndex" */ '@/views/management/index')
    },
    {
      path: '/management/login',
      name: 'managementLogin',
      component: () => import(/* webpackChunkName: "managementLogin" */ '@/views/management/login')
    },
    {
      path: '/management/set/:type',
      name: 'managementSet',
      component: () => import(/* webpackChunkName: "managementSet" */ '@/views/management/set'),
      children: [
        {
          path: 'alipay/:id',
          name: 'alipay-details',
          component: () => import(/* webpackChunkName: "alipay-details" */ '@/components/management/pay-setting/alipay-details')
        },
        {
          path: 'wxpay/:id',
          name: 'wxpay-details',
          component: () => import(/* webpackChunkName: "wxpay-details" */ '@/components/management/pay-setting/wxpay-details')
        },
        {
          path: 'channelpay/:id',
          name: 'channel-set',
          component: () => import(/* webpackChunkName: "channel-set" */ '@/components/management/pay-setting/channel-set')
        },
        {
          path: 'receiptSet/:model/type/:id',
          name: 'channel-receipt-set',
          component: () => import(/* webpackChunkName: "channel-receipt-set" */ '@/components/management/new-receipt-component/channel-receipt-set')
        },
        {
          path: 'receiptModelSet/:model/type/:id',
          name: 'receipt-model-set',
          component: () => import(/* webpackChunkName: "receipt-model-set" */ '@/components/management/new-receipt-component/receipt-model-set')
        },
        // 合同授权信息info页
        {
          path: 'contractAuthorizationInfo/:contractNo',
          name: 'contract-authorization-info',
          component: () => import(/* webpackChunkName: "contract-authorization-info" */ '@/components/management/authorization-component/contract-authorization-info')
        },
        {
          path: 'storeAllAuthorizaed',
          name: 'store-all-authorizaed',
          component: () => import(/* webpackChunkName: "store-all-authorizaed" */ '@/components/management/authorization-component/store-all-authorizaed')
        },
        {
          path: 'manageAllFacility',
          name: 'manage-all-facility',
          component: () => import(/* webpackChunkName: "manage-all-facility" */ '@/components/management/authorization-component/manage-all-facility')
        },
        {
          path: 'onlineMonitoring',
          name: 'online-monitoring',
          component: () => import(/* webpackChunkName: "manage-all-facility" */ '@/components/management/authorization-component/online-monitoring')
        },
        {
          path: 'storeAuthorizaedManage',
          name: 'store-authorizaed-manage',
          component: () => import(/* webpackChunkName: "store-authorizaed-manage" */ '@/components/management/authorization-component/store-authorizaed-manage')
        },
        {
          path: 'clearIdleList',
          name: 'clearIdleList',
          component: () => import(/* webpackChunkName: "clearIdleList" */ '@/components/management/authorization-component/clearIdleList')
        },
        {
          path: 'deviceChangeLog',
          name: 'deviceChangeLog',
          component: () => import(/* webpackChunkName: "deviceChangeLog" */ '@/components/management/authorization-component/deviceChangeLog')
        },
        {
          path: 'deviceUntiedLog',
          name: 'deviceUntiedLog',
          component: () => import(/* webpackChunkName: "deviceUntiedLog" */ '@/components/management/authorization-component/deviceUntiedLog')
        },
        // 短信
        {
          path: 'noteIndex',
          name: 'noteIndex',
          component: () => import(/* webpackChunkName: "noteIndex" */ '@/components/management/note/noteIndex')
        },
        {
          path: 'noteList',
          name: 'noteList',
          component: () => import(/* webpackChunkName: "noteList" */ '@/components/management/note/component/noteList')
        },
        {
          path: 'noNotePage',
          name: 'noNotePage',
          component: () => import(/* webpackChunkName: "noNotePage" */ '@/components/management/note/component/noNotePage')
        },
        {
          path: 'noteModules',
          name: 'noteModules',
          component: () => import(/* webpackChunkName: "noteModules" */ '@/components/management/note/component/noteModules')
        },
        {
          path: 'reportModules', // 报表配置模块
          name: 'reportModules',
          component: () => import(/* webpackChunkName: "reportModules" */ '@/components/management/report/reportModules')
        },
        {
          path: 'channelInfo',
          name: 'channelInfo',
          component: () => import(/* webpackChunkName: "channelInfo" */ '@/components/management/channelInfo/index')
        },
        {
          path: 'newNontElement',
          name: 'newNontElement',
          component: () => import(/* webpackChunkName: "newNontElement" */ '@/components/management/newNontElement/index')
        },
        {
          path: 'signatureElement',
          name: 'signatureElement',
          component: () => import(/* webpackChunkName: "signatureElement" */ '@/components/management/newNontElement/element/signatureElement')
        },
        {
          path: 'nontEditElement',
          name: 'nontEditElement',
          component: () => import(/* webpackChunkName: "nontEditElement" */ '@/components/management/newNontElement/element/nontEditElement')
        },
        // 公告
        {
          path: 'noticeIndex',
          name: 'noticeIndex',
          component: () => import(/* webpackChunkName: "noticeIndex" */ '@/components/management/notice/index')
        }
      ]
    },
    // 官网相关
    {
      path: '/index',
      component: Index,
      redirect: '/index/home',
      hidden: true,
      children: [
        {
          path: 'home',
          name: '主页',
          component: () => import(/* webpackChunkName: "home" */ '../views/pages/home.vue')
        },
        {
          path: 'product',
          name: '产品',
          component: () => import(/* webpackChunkName: "product" */ '@/views/pages/product')
        },
        {
          path: 'customer',
          name: '客户',
          component: () => import(/* webpackChunkName: "customer" */ '@/views/pages/customer')
        },
        {
          path: 'PCDownload',
          name: 'PC版下载',
          component: () => import(/* webpackChunkName: "PCDownload" */ '@/views/pages/PCDownload')
        },
        {
          path: 'download',
          name: '移动版下载',
          component: () => import(/* webpackChunkName: "download" */ '@/views/pages/download')
        },
        {
          path: 'customDownload',
          name: '定制版下载',
          component: () => import(/* webpackChunkName: "customDownload" */ '@/views/pages/customDownload')
        },
        {
          path: 'contactUs',
          name: '联系我们',
          component: () => import(/* webpackChunkName: "contactUs" */ '@/views/pages/contactUs')
        }
      ]
    },
    {
      path: '/paycall',
      name: 'pay-callback',
      component: () => import(/* webpackChunkName: "payCallback" */ '@/views/management/pay-callback')
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js